import React, { useEffect } from "react";
import { Button, DatePicker, Panel } from "rsuite";
import { updateAdmin, allAdminsVANS } from "../../store/modules/admin/actions";
import { useDispatch, useSelector } from "react-redux";

export default function VansAdminRegistros() {
  const dispatch = useDispatch();

  const { components, reservations, extraTime, extraTimeVans } = useSelector(
    (state) => state.admin
  );

  function convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);

    var mySQLDate = [date.getFullYear(), month, day].join("-");
    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join("T");
  }

  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  const setHorario = (key, value) => {
    dispatch(
      updateAdmin({
        extraTime: { ...extraTime, [key]: value },
      })
    );
  };
  const verVans = (vans) => {
    dispatch(
      updateAdmin({
        behavior: "Vans",
      })
    );

    dispatch(
      updateAdmin({
        extraTime: { ...vans },
      })
    );

    setComponent("header", false);
    setComponent("drawer", true);
  };

  const pesquisarVans = () => {
    dispatch(allAdminsVANS());
  };
  const criarHorario = () => {
    console.log("Criar horario!");
  };

  return (
    <div className="d-flex flex-column m-0 p-0 col-12 col-sd-11 col-xl-12 bg-black">
      <div className="   col-12 col-sd-12 col-md-12 col-xl-12  p-2 ">
        <b className="text-white ">Calendario Vans</b>
        <div>
          <button className="btn btn-success m-1" onClick={criarHorario}>
            {" "}
            Criar Horarios
          </button>
        </div>
        <div className="d-flex flex-row  ">
          <div className="d-flex flex-column  col-11 ">
            <DatePicker
              className="p-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              color="orange"
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("start_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />

            <DatePicker
              className="p-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("end_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />
          </div>
          <div className="d-flex flex-column justify-content-center">
            <button className="btn btn-success m-1 " onClick={pesquisarVans}>
              Pesquisar
            </button>
          </div>
        </div>
        <div className="d-flex flex-row  ">
          <div className="d-flex flex-column m-1 col-10 ">
            <input
              type="text"
              className="form-control "
              placeholder="Pesquisar por cliente ID:"
              disabled={true}
              value={""}
              onChange={(e) => []}
            />
          </div>
          <div className="d-flex flex-column justify-content-center">
            <button className="btn btn-success m-1 " onClick={pesquisarVans}>
              Pesquisar
            </button>
          </div>
        </div>
        <div className=" d-flex  flex-row flex-wrap ">
          {extraTimeVans.length > 0 ? (
            extraTimeVans.map((vans, index) => {
              return (
                <div className="d-flex flex-row text-white  rounded bg-dark m-1 text-center">
                  <Panel
                    key={`${index}vans.name`}
                    className="d-flex flex-row flex-wrap justify-content-center  text-center "
                  >
                    <div>
                      <p>
                        <b>{vans.name}</b>
                      </p>
                      <p>
                        <small>{}</small>
                      </p>
                    </div>

                    <div className=" d-flex col-12 text-center size-sm ">
                      <Button
                        appearance="primary"
                        color="green"
                        size="sm"
                        className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                        onClick={() => {
                          verVans(vans);
                        }}
                      >
                        {" "}
                        Ver
                      </Button>
                    </div>
                  </Panel>
                </div>
              );
            })
          ) : (
            <h3>
              Escolha data de inicio e final ou so faça click no button
              pesquisar
            </h3>
          )}
        </div>
      </div>
    </div>
  );
}
